/* global dataLayer */
/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import {
  getEmailError,
  getNameError,
  convertNameCase,
  formValid,
  trackEvent,
} from '../../libs';
import { setUserName, setUserEmail, setUserAgree, setSubmitStatus, reset } from '../../actions';
import { submitForm } from '../../api';
import './Form.scss';

class Form extends React.Component {
  constructor(props) {
    super(props);
    this.setName = this.setName.bind(this);
    this.focusName = this.focusName.bind(this);
    this.blurName = this.blurName.bind(this);
    this.setEmail = this.setEmail.bind(this);
    this.focusEmail = this.focusEmail.bind(this);
    this.blurEmail = this.blurEmail.bind(this);
    this.setAgree = this.setAgree.bind(this);
    this.submit = this.submit.bind(this);
    this.clear = this.clear.bind(this);
  }

  componentWillMount() {
    this.setState({ nameError: false, formError: null });
    this.setState({ emailError: false, formError: null });
  }

  setName(e) {
    this.props.dispatch(setUserName(convertNameCase(e.target.value)));
  }

  focusName() {
    this.notError('name');
  }

  blurName(e) {
    this.errorOrNotError('name', e.target.value);

    trackEvent({
      eventCategory: 'Form',
      eventAction: 'Brochure Form Name',
    });
  }

  setEmail(e) {
    this.props.dispatch(setUserEmail(e.target.value));
  }

  focusEmail() {
    this.notError('email');
  }

  blurEmail(e) {
    this.errorOrNotError('email', e.target.value);

    trackEvent({
      eventCategory: 'Form',
      eventAction: 'Brochure Form Email',
    });
  }

  setAgree(e) {
    this.props.dispatch(setUserAgree(e.target.checked));

    if (e.target.checked) {
      trackEvent({
        eventCategory: 'Form',
        eventAction: 'Brochure Form Agree',
      });
    }
  }

  errorOrNotError(_name, _value) {
    const name = `${_name}Error`;
    const email = `${_name}Error`;
    let error = true;

    switch (_name) {
      case 'name':
        error = getNameError(_value);
        break;
      case 'email':
        error = getEmailError(_value);
        break;
      default:
        error = true;
        break;
    }

    this.setState({ [name]: error });
    this.setState({ [email]: error });
  }

  notError(_name) {
    this.setState({ [`${_name}Error`]: false });
  }

  clear() {
    const { dispatch } = this.props;

    dispatch(setUserName(null));
    dispatch(setUserEmail(null));
    dispatch(reset());
  }

  submit(e) {
    const { user, brochures, dispatch } = this.props;

    e.preventDefault();

    // if (dataLayer && dataLayer.push) {
    //   dataLayer.push({ event: 'send' });
    // }

    this.errorOrNotError('name', user.name);
    this.errorOrNotError('email', user.email);

    const brochureLinks = [];
    const brochureNames = [];

    brochures.forEach(i => {
      brochureLinks.push(i.value);
      brochureNames.push(i.name);
    });

    if (brochureLinks.length === 0) {
      this.setState({ formError: 'Выберите брошюру' });

      return;
    }

    if (formValid(user) === false) {
      this.setState({ formError: 'Проверьте обязательные для заполнения поля' });
      return;
    }

    // trackInjectionEvent({
    //   eventclass: "workflowevent",
    //   category: "tools",
    //   componentname: "brochure_request",
    //   action: "form_workflow",
    //   value: "form-submit",
    //   workflowname: "brochure_request",
    //   workflowstep: "2",
    //   workflowconversion: "1"
    // });

    this.setState({ formError: null });

    user.news_subscription = user.news_subscription ? 1 : 0;

    submitForm({
      name: user.name,
      email: user.email,
      brochures: brochureLinks,
      news_subscription: user.news_subscription,
    }, () => {
      dispatch(setSubmitStatus('success'));

      this.clear();

      trackEvent({
        eventCategory: 'Brochure send',
        eventAction: 'submit',
        eventLabel: 'Contacts',
      });

      // if (dataLayer && dataLayer.push) {
      //   dataLayer.push({ event: 'submit' });
      // }
      if (window.dataLayer && dataLayer.push) {
        dataLayer.push({
          event: 'submit',
          eventCategory: 'Brochure send',
          eventAction: 'submit',
          eventLabel: 'Contacts'
        });

        dataLayer.push({'event': 'brochure_soloway'});
      }

      let _rutarget = window._rutarget || [];
      _rutarget.push({'event': 'thankYou', 'conv_id': 'brochure'});

    }, () => {
      dispatch(setSubmitStatus('error'));
    });
  }

  render() {
    const { user } = this.props;

    let nameError = null;
    if (this.state.nameError) {
      nameError = <div className="form__error">{this.state.nameError}</div>;
    }

    let emailError = null;
    if(this.state.emailError) {
      emailError = <div className="form__error">{this.state.emailError}</div>;
    }

    /*const agreeError = !user.agree && <div className="form__error">
      Необходимо ваше согласие на обработку персональных данных
    </div>;*/

    const formError = this.state.formError && <div className="form__error">
      {this.state.formError}
    </div>;

    return (
      <form className="form">
        <div className="row">
          <div
            className={classNames({
              'col-xs-12 col-sm-6 form__item': true,
              'error': !!nameError,
            })}
          >
            <label htmlFor="user-name">Ваше имя<sup>*</sup></label>
            <input
              id="user-name"
              ref="user-name"
              className="input"
              placeholder="Иван"
              type="text"
              onChange={this.setName}
              value={user.name || ''}
              onFocus={this.focusName}
              onBlur={this.blurName}
            />
            {nameError}
          </div>

          <div
            className={classNames({
              'col-xs-12 col-sm-6 form__item': true,
              'error': !!emailError,
            })}
          >
            <label htmlFor="user-email">E-mail<sup>*</sup></label>
            <input
              id="user-email"
              className="input"
              placeholder="info@info.ru"
              type="email"
              onChange={this.setEmail}
              value={user.email || ''}
              onFocus={this.focusEmail}
              onBlur={this.blurEmail}
            />
            {emailError}
          </div>

          <div className="col-xs-12">
            <div className="form__disclaimer">
              СОГЛАСИЕ НА ОБРАБОТКУ ПЕРСОНАЛЬНЫХ ДАННЫХ (далее&nbsp;&mdash; Согласие)
              <br />

              ООО «Тойота Мотор» (далее&nbsp;&mdash; Общество), расположенное по&nbsp;адресу: 141031, Россия,
              Московская обл., г.&nbsp;о.&nbsp;Мытищи, п.&nbsp;Вёшки, МКАД, 84-й&nbsp;км, ТПЗ&nbsp;«Алтуфьево»,
              вл.&nbsp;5, стр.&nbsp;1, является оператором персональных данных.
              <br />

              1. Настоящим я даю согласие Обществу на&nbsp;обработку своих персональных данных, а&nbsp;именно: имени,
              отчества, фамилии, контактных данных (включая номер телефона и&nbsp;адрес электронной почты), адреса,
              сведений о&nbsp;впечатлениях, интересах, предпочтениях к&nbsp;автомобилю(-ям) и&nbsp;товарам/услугам,
              IP-адреса, сведений об&nbsp;устройстве, операционной системы устройства и&nbsp;модели мобильного телефона
              посетителя сайта, уникального идентификатора посетителя сайта, предпочтительного времени и&nbsp;способа
              для&nbsp;контакта, истории контактов.
              <br />

              2. Под&nbsp;обработкой персональных данных понимаются следующие действия: сбор, запись, систематизация,
              накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передача
              (предоставление, доступ), блокирование, удаление, уничтожение персональных данных. Общество обрабатывает
              персональные данные с&nbsp;использованием средств автоматизации.
              <br />

              3. Целью обработки персональных данных является осуществление взаимодействия Общества с&nbsp;посетителями
              и&nbsp;пользователями сайта.
              <br />

              4. Я даю согласие на&nbsp;передачу моих персональных данных третьим лицам, перечень которых размещен
              на&nbsp;сайте в&nbsp;разделе «Юридическая информация».
              <br />

              5. Данное Согласие действует до&nbsp;момента достижения цели обработки, указанной в&nbsp;настоящем
              Согласии. Я&nbsp;осведомлен, что&nbsp;Общество будет обрабатывать данные только в&nbsp;случае, если это
              необходимо для&nbsp;определенной цели, и&nbsp;может запросить, чтобы я&nbsp;продлил срок действия своего
              согласия на&nbsp;обработку по&nbsp;истечении 10&nbsp;лет с&nbsp;тем, чтобы гарантировать, что&nbsp;оно
              соответствует моим намерениям.
              <br />

              6. Согласие может быть отозвано путем направления письменного заявления Обществу заказным почтовым
              отправлением с&nbsp;описью вложения по адресу: 141031, Московская обл., г.&nbsp;о.&nbsp;Мытищи,
              п.&nbsp;Вёшки, МКАД 84-й&nbsp;км, ТПЗ&nbsp;«Алтуфьево», вл.&nbsp;5, стр.&nbsp;1.
            </div>
            <div className="car-catalog__intro">
              Отправляя данную форму, я даю согласие на&nbsp;обработку
              своих персональных данных.
            </div>
            <div className="form__agree">
              <label className="c-control">
                <input
                  type="checkbox"
                  id="data-agree"
                  checked={user.news_subscription}
                  onChange={this.setAgree}
                  className="car-catalog__data-agree"
                />
                <i className="c-control__icon"/>
                <span className="c-control__text">
                  Настоящим в&nbsp;дополнение к&nbsp;целям, указанным в&nbsp;п.&nbsp;3
                  Согласия, я разрешаю обрабатывать свои персональные данные с&nbsp;целью
                  продвижения товаров, работ, услуг Общества на&nbsp;рынке, путем
                  осуществления прямых контактов, а&nbsp;также выражаю свое согласие
                  на&nbsp;получение рекламной информации любым доступным способом,
                  включая сети электросвязи, а&nbsp;также через сеть интернет.
                </span>
              </label>
            </div>
            <div className="form__required">
              <span>*</span> Поля, обязательные для заполнения
            </div>

            {formError}

            <button
              onClick={this.submit}
              className="btn btn-action-primary form__submit subscribe_soloway"
              id="submitButton"
            >
              Отправить
            </button>
          </div>
        </div>
      </form>
    );
  }
}

Form.propTypes = {
  dispatch: PropTypes.func,
  user: PropTypes.object,
  brochures: PropTypes.array.isRequired,
};

export default connect(store => ({
  user: {
    name: store.mainReducer.name,
    email: store.mainReducer.email,
    news_subscription: store.mainReducer.news_subscription,
  },
}))(Form);



// WEBPACK FOOTER //
// ./src/components/Form/Form.js